import { Button, Col, Form, Input, Modal, notification, Row } from 'antd';
import React, { useCallback, useEffect } from 'react';

import { DefaultMode, Mode } from '../../models/Mode';

interface IProps {
  selectedMode?: Mode | DefaultMode;
  submitting?: boolean;
  error: Error | null;
  onSubmit: (mode: Mode) => void;
  onClose: () => void;
}

const ModeDialog: React.FC<IProps> = ({
  error,
  onClose,
  onSubmit,
  selectedMode,
  submitting,
}) => {
  const [form] = Form.useForm();

  const closeModal = useCallback(() => {
    form.resetFields();
    onClose();
  }, [form, onClose]);

  const submitForm = useCallback(
    (mode: Mode) => {
      if (selectedMode) {
        mode.id = selectedMode.id;
      }
      onSubmit(mode);
    },
    [onSubmit, selectedMode]
  );

  useEffect(() => {
    if (selectedMode) {
      form.setFieldsValue(selectedMode);
    }
  }, [form, selectedMode]);

  useEffect(() => {
    if (error) {
      notification.error({
        description: error.message,
        message: error.name,
      });
    }
  }, [error]);

  return (
    <Modal
      centered
      visible
      footer={null}
      maskClosable={false}
      title={!selectedMode ? 'Add Mode' : 'Edit Mode'}
      width={400}
      onCancel={closeModal}
    >
      <Form form={form} layout="vertical" onFinish={submitForm}>
        <Row gutter={24}>
          <Col span={24}>
            <Form.Item
              label="Transportation Mode Name"
              name="name"
              rules={[{ message: 'Mode name is required!', required: true }]}
            >
              <Input />
            </Form.Item>
          </Col>

          <Col span={24}>
            <Form.Item label="Notes" name="notes">
              <Input.TextArea rows={5} />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={24}>
          <Col span={12}>
            <Form.Item>
              <Button className="modal-close-btn" onClick={closeModal}>
                Cancel
              </Button>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item>
              <Button
                className="modal-save-btn"
                htmlType="submit"
                loading={submitting}
                type="primary"
              >
                SAVE
              </Button>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default ModeDialog;
